import { gql } from "@apollo/client";

export const VOID_ENFORCEMENT_INTENT = gql`
  mutation VoidEnforcementIntent($id: uuid!, $reason: String!, $voidedAt: timestamptz!) {
    void_enforcement_intent(id: $id, reason: $reason, voided_at: $voidedAt) {
      enforcementIntentId: enforcement_intent_id
      voidedAt: voided_at
      reason
      updatedAt: updated_at
    }
  }
`;

export interface VoidEnforcementIntentData {
  void_enforcement_intent: {
    enforcementIntentId: string;
    voidedAt: string;
    reason: string;
    updatedAt: string;
  };
}

export interface VoidEnforcementIntentVars {
  id: string;
  reason: string;
  voidedAt: Date;
}

export default VOID_ENFORCEMENT_INTENT;
